import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import { DatePickerNew, Select } from 'common-src/components/base';
import {
  AssessmentTypeOptions,
  UnalignmentReasonOptions,
  validatePatientGuideCmsAlignment,
} from 'common-src/models/PatientGuideCmsAlignment';
import { ColorsNew } from 'common-src/styles';

const Unalignment = ({ data, handleInputChange, errors, setErrors }) => (
  <>
    <Select
      id="assessment-type"
      label="Assessment type"
      options={AssessmentTypeOptions}
      onChange={(op) => handleInputChange('assessmentType', op.value)}
      value={AssessmentTypeOptions.find((op) => op.value === data.assessmentType)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
    />
    <Select
      id="unalignment-reason"
      label="Unalignment reason"
      placeholder="Select"
      options={UnalignmentReasonOptions}
      onChange={(op) => handleInputChange('unalignmentReason', op.value)}
      value={UnalignmentReasonOptions.find((op) => op.value === data.unalignmentReason)}
      required
      requiredColor={ColorsNew.mediumDarkRed}
    />
    <DatePickerNew
      id="unalignment-effective-date"
      header="Unalignment effective date"
      placeholder="Select date"
      value={data.unEffectiveDate}
      onDateSelected={(date) => {
        handleInputChange('unEffectiveDate', date ? moment(date).format('YYYY-MM-DD') : null);
        setErrors((prev) => ({
          ...prev,
          ...validatePatientGuideCmsAlignment('unEffectiveDate', date),
        }));
      }}
      onBlur={(date) =>
        setErrors((prev) => ({
          ...prev,
          ...validatePatientGuideCmsAlignment('unEffectiveDate', date),
        }))
      }
      errorText={errors.unEffectiveDate}
      required
      requiredColor={ColorsNew.mediumDarkRed}
      maxDate={new Date()}
    />
  </>
);

Unalignment.propTypes = {
  data: PropTypes.object,
  handleInputChange: PropTypes.func,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
};

export default Unalignment;
